var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco1Proceso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico_1_proceso",
    transform: "translate(-308 -1911)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_1_proceso-2",
    "data-name": "ico_1_proceso",
    transform: "translate(308 1911)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6458",
    "data-name": "Rectangle 6458",
    width: 228,
    height: 228,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8127",
    "data-name": "Group 8127",
    transform: "translate(330.325 1934.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19641",
    "data-name": "Path 19641",
    d: "M388.94,366.778c-3.118-11.238-.918-20.934,8.83-27.645,10.275-7.073,20.412-4.9,30.126,2.246.275-1.5.514-2.908.788-4.306,1.973-10.027,7.91-16.55,17.8-18.9,9.932-2.362,17.93,1.4,24.209,9.135a1.868,1.868,0,0,0,2.427.8c11.848-3.684,22.722-1.81,31.968,6.569,9.416,8.533,12.245,19.353,9.674,31.685a1.966,1.966,0,0,0,.025.428c1.9.614,3.877,1.127,5.757,1.879,7.891,3.157,13.327,8.439,15.113,17.1,2.748,13.328-7.747,27.1-21.345,27.548-7.445.246-14.9.106-22.356.11q-29.313.015-58.626-.029a3.347,3.347,0,0,0-3.161,1.577c-9.658,13.634-28.922,13.587-38.539-.088a3.345,3.345,0,0,0-2.864-1.563c-12.385-.794-21.892-11.745-21.392-24.137.49-12.138,8.664-19.412,19.7-21.967C387.688,367.075,388.3,366.928,388.94,366.778Z",
    transform: "translate(-352.746 -301.881)",
    fill: "#80cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19642",
    "data-name": "Path 19642",
    d: "M522.145,371.9c-.943,3.122-1.489,6.437-2.9,9.33-5.022,10.3-13.459,15.768-24.876,16.642-.993.076-1.994.058-2.991.058q-37.416,0-74.832-.024a3.61,3.61,0,0,0-3.111,1.432,29.032,29.032,0,0,1-44.323.006A5.2,5.2,0,0,0,365.8,397.4a28.979,28.979,0,0,1-4.808-55.808c1.365-.5,1.365-1.26,1.3-2.383-.7-11.991,4.063-21.276,14.291-27.467,8.189-4.957,16.936-5.358,25.844-1.829.531.211,1.059.427,1.345.542,1.712-2.992,3.1-6.067,5.06-8.717a27.816,27.816,0,0,1,19.2-11.228,3.768,3.768,0,0,0,.793-.3h6.339a11.725,11.725,0,0,0,1.32.367,27.4,27.4,0,0,1,15.854,8.064,4.055,4.055,0,0,0,4.4,1.251,35.1,35.1,0,0,1,26.087,4.281c13.11,7.944,19.421,19.737,18.836,35.109-.046,1.214.168,1.841,1.437,2.306a27.454,27.454,0,0,1,16.06,14.654c1.4,3.039,2.019,6.438,2.992,9.674ZM369.274,345.428c-.637.15-1.253.3-1.869.44-11.033,2.556-19.208,9.83-19.7,21.967-.5,12.392,9.008,23.343,21.392,24.137a3.344,3.344,0,0,1,2.864,1.563c9.617,13.674,28.881,13.721,38.539.087a3.349,3.349,0,0,1,3.161-1.577q29.313.072,58.626.029c7.452,0,14.911.137,22.356-.11,13.6-.45,24.093-14.219,21.345-27.547-1.786-8.66-7.223-13.943-15.113-17.1-1.88-.752-3.855-1.265-5.757-1.879a1.965,1.965,0,0,1-.025-.428c2.571-12.333-.257-23.153-9.674-31.686-9.246-8.378-20.121-10.253-31.968-6.568a1.869,1.869,0,0,1-2.427-.8c-6.279-7.732-14.277-11.5-24.209-9.136-9.888,2.351-15.826,8.874-17.8,18.9-.275,1.4-.514,2.8-.788,4.306-9.714-7.148-19.851-9.32-30.126-2.247C368.356,324.494,366.155,334.19,369.274,345.428Z",
    transform: "translate(-341.813 -290.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19643",
    "data-name": "Path 19643",
    d: "M549.333,551.912c4.3,5.355,8.661,10.3,11.12,16.483,2.168,5.455-2.259,12.43-8.6,13.8a11.478,11.478,0,0,1-14.014-10.981,13.269,13.269,0,0,1,1.751-5.6,46.144,46.144,0,0,1,3.939-6.227C545.3,556.924,547.25,554.578,549.333,551.912Zm.368,9.031-.745-.006c-1.638,2.682-3.388,5.3-4.879,8.067a5.14,5.14,0,0,0,1.666,6.422,5.9,5.9,0,0,0,7.179,0A5.142,5.142,0,0,0,554.583,569C553.095,566.241,551.341,563.623,549.7,560.943Z",
    transform: "translate(-425.719 -402.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19644",
    "data-name": "Path 19644",
    d: "M505.917,505.765c4.506,5.621,8.925,10.593,11.356,16.868,1.8,4.657-1.438,10.845-6.619,13.031-7.553,3.186-16.14-2.337-16-10.508a12.083,12.083,0,0,1,1.979-5.877C499.468,514.783,502.634,510.495,505.917,505.765Zm.611,9.2-.766.034c-1.7,2.836-3.532,5.6-5.044,8.533-1.023,1.983-.009,4.6,1.918,6.052a5.82,5.82,0,0,0,6.736.184c2.009-1.368,3.249-3.992,2.29-5.936C510.153,520.772,508.259,517.907,506.528,514.96Z",
    transform: "translate(-407.234 -382.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19645",
    "data-name": "Path 19645",
    d: "M592.512,506.243c3.972,4.952,7.671,9.666,10.563,15.032,2.9,5.388-.778,14.045-8.5,15.287a11.472,11.472,0,0,1-13.628-10.777,7.076,7.076,0,0,1,.505-3.077C583.924,516.516,588.26,511.573,592.512,506.243Zm.378,8.959-.77-.036c-1.731,2.945-3.624,5.81-5.132,8.865-.953,1.931.3,4.592,2.286,5.944a5.819,5.819,0,0,0,6.734-.2c1.938-1.48,2.955-4.075,1.934-6.051C596.427,520.8,594.589,518.035,592.889,515.2Z",
    transform: "translate(-444.163 -382.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19646",
    "data-name": "Path 19646",
    d: "M462.909,552.007c4.253,5.285,8.593,10.231,11.067,16.42,1.9,4.744-1.417,11.163-6.72,13.263a11.582,11.582,0,0,1-15.9-10.414,6.778,6.778,0,0,1,.392-2.578C454.212,562.375,458.6,557.35,462.909,552.007Zm.311,8.961-.718,0c-1.641,2.688-3.4,5.315-4.886,8.084a5.082,5.082,0,0,0,1.67,6.412,5.867,5.867,0,0,0,7.176,0,5.094,5.094,0,0,0,1.659-6.421C466.626,566.276,464.866,563.653,463.22,560.969Z",
    transform: "translate(-388.7 -402.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19647",
    "data-name": "Path 19647",
    d: "M419.657,506.18a102.82,102.82,0,0,1,10.557,15c2.964,5.438-.77,14.211-8.584,15.368-7.171,1.062-13.12-3.682-13.436-10.921A12.363,12.363,0,0,1,409.844,520a46.571,46.571,0,0,1,4.04-6.38C415.661,511.156,417.606,508.808,419.657,506.18Zm.382,9-.705.033c-1.649,2.682-3.412,5.3-4.91,8.067a5.145,5.145,0,0,0,1.688,6.423,5.8,5.8,0,0,0,7.168-.027,5.082,5.082,0,0,0,1.648-6.414C423.434,520.494,421.68,517.866,420.038,515.179Z",
    transform: "translate(-370.224 -382.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19648",
    "data-name": "Path 19648",
    d: "M578.265,352.193h0a2.868,2.868,0,0,1-2.828-2.352c-1.771-9.862-7.582-15.733-17.626-17.536a2.84,2.84,0,0,1-2.326-2.849v-.07a2.837,2.837,0,0,1,3.09-2.792c11.784,1.186,21.43,11.288,22.555,22.431A2.881,2.881,0,0,1,578.265,352.193Z",
    transform: "translate(-433.273 -305.779)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 107.233,
    cy: 107.233,
    r: 107.233,
    transform: "translate(315 1918)",
    fill: "#fff",
    opacity: 0.23,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco1Proceso);
export default __webpack_public_path__ + "static/media/ico_1_proceso.32b7dd2d67fb9037797a793d7f5f19f7.svg";
export { ForwardRef as ReactComponent };